import { render, staticRenderFns } from "./InstrumentGroupEdit.vue?vue&type=template&id=45b6aa7e&"
import script from "./InstrumentGroupEdit.vue?vue&type=script&lang=js&"
export * from "./InstrumentGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports